import { z } from 'zod'

export const socialAccountConfig = {
  instagram: {
    label: 'Instagram',
    propertyName: 'instagramUserId',
    urlPrefix: 'https://www.instagram.com/',
    altUrlPrefixes: ['https://instagram.com/', '@'],
    placeholder: 'ユーザーネーム',
    validationSchema: undefined,
  },
  instagramTreads: {
    label: 'Threads',
    propertyName: 'instagramUserId',
    urlPrefix: 'https://www.threads.net/@',
    altUrlPrefixes: ['https://www.instagram.com/', 'https://instagram.com/'],
    placeholder: 'ユーザーネーム',
    validationSchema: undefined,
  },
  facebook: {
    label: 'Facebook',
    propertyName: 'facebookUserId',
    urlPrefix: 'https://www.facebook.com/p/',
    altUrlPrefixes: [
      'https://facebook.com/p/',
      'https://m.facebook.com/p/',
      'https://www.facebook.com/',
      'https://facebook.com/',
      'https://m.facebook.com/',
      'https://www.facebook.com/profile.php?id=',
    ],
    placeholder: 'ユーザーネーム or ID',
    validationSchema: undefined,
  },
  twitter: {
    label: 'X（旧Twitter）',
    propertyName: 'twitterUserId',
    urlPrefix: 'https://twitter.com/',
    altUrlPrefixes: ['https://www.twitter.com/'],
    placeholder: 'ユーザー名',
    validationSchema: undefined,
  },
  tabelog: {
    label: '食べログ',
    propertyName: 'tabelogUserId',
    urlPrefix: 'https://tabelog.com/rvwr/',
    altUrlPrefixes: ['https://www.tabelog.com/rvwr/'],
    placeholder: 'レビュアーID',
    validationSchema: z
      .string()
      .regex(/^[a-zA-Z0-9]*$/, '半角英数字のみで入力してください'),
  },
  youtube: {
    label: 'YouTube',
    propertyName: 'youtubeChannelId',
    urlPrefix: 'https://www.youtube.com/',
    altUrlPrefixes: ['https://youtube.com/', 'https://m.youtube.com/'],
    placeholder: 'チャンネルID',
    validationSchema: undefined,
  },
  tiktok: {
    label: 'TikTok',
    propertyName: 'tiktokUserId',
    urlPrefix: 'https://www.tiktok.com/',
    altUrlPrefixes: ['https://tiktok.com/'],
    placeholder: '@ユーザー名',
    validationSchema: undefined,
  },
  litlink: {
    label: 'lit.link',
    propertyName: 'litlinkUserId',
    urlPrefix: 'https://lit.link/',
    altUrlPrefixes: ['https://www.lit.link/'],
    placeholder: 'ユーザー名',
    validationSchema: undefined,
  },
} as const

export type SocialAccountType = keyof typeof socialAccountConfig

export const normalizeSocialAccountName = (
  type: keyof typeof socialAccountConfig,
  userName: string
) => {
  let normalizedUserName = userName
  // remove prefix
  for (const prefix of [
    socialAccountConfig[type].urlPrefix,
    ...socialAccountConfig[type].altUrlPrefixes,
  ]) {
    if (userName.startsWith(prefix) && userName.length > prefix.length) {
      normalizedUserName = userName.replace(prefix, '')
      break
    }
  }

  // remove query parameter
  normalizedUserName = normalizedUserName.split('?')[0] ?? normalizedUserName

  // remove trailing slash
  normalizedUserName = normalizedUserName.replace(/\/$/, '')

  return normalizedUserName
}

export const socialAccountNameUrl = (
  type: keyof typeof socialAccountConfig,
  userName: string
) => {
  return (
    socialAccountConfig[type].urlPrefix +
    normalizeSocialAccountName(type, userName)
  )
}
